import ModalImprimirFactura from '../../../../components/Modals/ModalsFacturacion/ModalImprimirFactura'
import ModalEnviarEmail from '../../../../components/Modals/ModalsFacturacion/ModalEnviarEmail'
import ModalEmitir from '../../../../components/Modals/ModalsFacturacion/ModalEmitir'
import {State} from '../../../../reducers'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision, actionsAnulaciones, actionsOperaciones} from '../../../../actions/action-creators'
import {OPSendEmail} from '../../../../interfaces/operaciones.interface'
import {emailInvoice} from '../../../../utils/invoice/validateSendInvoice'
import {generalOpenModalMessage} from '../../../../actions/general.actions'

import {useHistory} from 'react-router'
import ModalsResumenDocEmitidoV1 from './ModalsResumenDocEmitidoV1'
import ModalAnularFactura from '../../../../components/Modals/ModalsFacturacion/ModalAnularFactura'
import { anularFactura } from '../../../../actions/operaciones/operaciones.actions'
import { useEffect, useMemo } from 'react'
import { historialHandleAnulaciones } from '../../../../actions/historial/historialFilter.actions'
import { convertDateFormatAnular } from '../../../../utils/stringDate'
import { MotivoAnulacion } from '../../../../components/Modals/ModalsFacturacion/CamposMotivoAnulacion'

const ModalsResumenControlV1 = () => {
  const {modals, datosFacturaRes, datosEmisor, formCliente, formSucursal, calculosArrayProductos} = useSelector((state: State) => state.facturacion)
  const {resultAnulaciones} = useSelector((state: State) => state.historial);
  const {activeDoc} = useSelector((state: State) => state.documentos)
  const loader = useSelector((state: State) => state.general.loader)
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionFacturacionEmision, dispatch)
  const {sendTransactionEmail} = bindActionCreators(actionsOperaciones, dispatch)
  const actionsAN = bindActionCreators(actionsAnulaciones, dispatch)
  const history = useHistory()
  const {datos} = useSelector((state: State) => state.userLogin)

  const handleEnviarEmail = async (formEnvio: emailInvoice) => {
    if (loader) return
    const sendEmail: OPSendEmail = {
      Correo: formEnvio.email.trim(),
      Documento: datosFacturaRes?.JsonFactura,
      Sello: datosFacturaRes?.Sello,
      json: datosFacturaRes?.JsonFacturaFile || "",
      idSucursal: datos?.sucursal_seleccionada,
      idEmpresa: `${datos?.codigo_empresa}`
    }

    if (await sendTransactionEmail(sendEmail)) {
      dispatch(generalOpenModalMessage(`Enviar por correo electrónico`, `El correo fue enviado exitosamente.`))
      actionsFE.facturacionOpenCloseModalEmail(false)
    }
  }

  const handleClicEmitir = () => {
    switch(activeDoc.idDoc) {
      default:
        actionsFE.facturacionClicEmitirModal(history) 
        break;
    }
  }

  const handleAnular = (motivo: MotivoAnulacion) => {
    switch(activeDoc.idDoc) {      
      case '05':
        actionsAN.anularNotaCredito(motivo);
        break;

      default:
        const anularDoc = {
          documento: datosFacturaRes.JsonFactura,
          sellorecibido: datosFacturaRes.Sello,
          DetallesDTE: {
            receptor: {
              numDocumento: formCliente.numId?.trim().replace(/-/g, ""),
              tipoDocumento: formCliente.tipoDocumento,
              nrc: formCliente.nrc?.trim(),
              nombre: formCliente.nombre?.trim(),
              telefono: formCliente.telefono?.trim(),
              correo: formCliente.email?.trim(),
            },
            emisor: {
              nombre: datosEmisor.nombre,
              nit: datosEmisor.nit,
              nrc: datosEmisor.nrc,
              telefono: datosEmisor.telefono,
              correo: datosEmisor.correo,
              tipoEstablecimiento: datosEmisor.tipoestablecimiento,
            },
            resumen: {
              totalIva: calculosArrayProductos.totalImpuesto1,
            },
            identificacion: { 
              tipoDte: activeDoc.idDoc,
              codigoGeneracion: datosFacturaRes.codigoGeneracion,
              numeroControl: "DTE-" + activeDoc.idDoc + "-" + formSucursal.datosSerie.serie + "-" + formSucursal.datosSerie.numeroactual,
              fecEmi: convertDateFormatAnular(datosFacturaRes.fhProcesamiento.split(" ")[0]),
            }
          }
        }
    
        dispatch(anularFactura([anularDoc], motivo));
        break;
    } 
  }

  useEffect(() => {
    if (resultAnulaciones.length > 0) {
      dispatch(historialHandleAnulaciones());
      actionsFE.facturacionOpenCloseModalAnularV2(false);

      if (resultAnulaciones[0].result) {
        if (activeDoc.idDoc === "05") history.push("/history-invoice");
        else history.push("/otros-documentos");
      }
    }
  }, [resultAnulaciones]);

  const titlesModalEmitir = useMemo(() => {
    switch(activeDoc.idDoc) {
      case "05":
        return ["Emitir nota de crédito", "Estás a punto de emitir esta nota de crédito, ¿deseas continuar?"];  

      default:
        return ["Emitir comprobante", "Estás a punto de emitir este comprobante, ¿deseas continuar?"];
    }
  }, []);

  return (
    <>
      {modals.activeEmitirFactura && (
        <ModalEmitir
          title={titlesModalEmitir[0]}
          detail={titlesModalEmitir[1]}
          ClicCancelar={actionsFE.facturacionCloseModalEmitir}
          ClicEmitir={handleClicEmitir}
        />
      )}
      {modals.activeFacturaEmitida && <ModalsResumenDocEmitidoV1 />}
      {modals.activeImpresion && (
        <ModalImprimirFactura
          title='Imprimir Documento'
          detail='¿Deseas imprimir este documento?'
          documento={datosFacturaRes?.JsonFactura}
          sello={datosFacturaRes?.Sello}
          onCancel={() => actionsFE.facturacionOpenCloseModalImprimir(false)}
          onPrint={() => actionsFE.facturacionOpenCloseModalImprimir(false)}
        />
      )}
      {(modals.activeAnular) && 
        (<ModalAnularFactura 
          closeModalEliminar={() => actionsFE.facturacionOpenCloseModalAnularV2(false)}
          actionEliminar={handleAnular}
          detail={"DTE-" + activeDoc.idDoc + "-" + formSucursal.datosSerie.serie + "-" + formSucursal.datosSerie.numeroactual}
        />)
      }
      {modals.activeEmail && (
        <ModalEnviarEmail
          email={formCliente.email}
          showBackBtn={true}
          onBackBtn={() => actionsFE.facturacionOpenCloseModalEmail(false)}
          onSendEmail={handleEnviarEmail}
        />
      )}
    </>
  )
}

export default ModalsResumenControlV1
